import type { TonyteActivity } from '../types';

// Curated Dresden events – 11 May 2026
// Image URLs point to Tonyte's public web host.
// Restore live Firestore reads when Firebase is re-enabled.

const IMG = (filename: string) =>
  `https://tonyte.app/event-images/${filename}`;

export const DRESDEN_MAY_11_EVENTS: TonyteActivity[] = [
  {
    id: 'dresden-may11-magdalena-wawra',
    title: 'Magdalena Wawra – "Ich bin viele" Tour',
    description:
      'Magdalena Wawra brings her emotional and atmospheric "Ich bin viele" tour to Altes Wettbüro. Expect intimate vocals, indie-pop energy, and a deeply personal live performance inside one of Dresden\'s most iconic underground cultural venues. With layers of synthesizers, acoustic guitar, and her unmistakable voice, Wawra weaves stories of identity, transformation, and self-discovery.',
    location: 'Antonstr. 8, 01097 Dresden',
    address: 'Antonstr. 8, 01097 Dresden',
    venueName: 'Altes Wettbüro',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Altes Wettbüro',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '20:00',
    endTime: '23:00',
    coordinates: { lat: 51.0629, lng: 13.7367 },
    coverImageUrl: IMG('Candlelight_concert_in_hall_202605090203.jpeg'),
    coverPhoto: IMG('Candlelight_concert_in_hall_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Indie Pop', 'Singer-Songwriter'],
    hashtags: ['Indie', 'LiveMusic', 'Dresden', 'Concert', 'MagdalenaWawra'],
    tags: ['indie', 'singer-songwriter', 'live-music', 'concert'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-tabita-live',
    title: 'Tabita Live',
    description:
      'Ostpol hosts a live performance by Tabita featuring dreamy alternative-pop sounds and emotional songwriting. Tabita crafts introspective soundscapes where layered harmonies drift over delicate chord progressions — music that feels like late-night conversations you never forget. A cozy Monday concert atmosphere in Dresden Neustadt.',
    location: 'Königsbrücker Str. 47, 01099 Dresden',
    address: 'Königsbrücker Str. 47, 01099 Dresden',
    venueName: 'Ostpol',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Ostpol',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '20:00',
    endTime: '23:30',
    coordinates: { lat: 51.0661, lng: 13.7382 },
    coverImageUrl: IMG('Candlelight_concert_in_hall_202605090203_2.jpeg'),
    coverPhoto: IMG('Candlelight_concert_in_hall_202605090203_2.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Pop', 'Alternative'],
    hashtags: ['Ostpol', 'LiveMusic', 'Pop', 'Alternative', 'DresdenNight'],
    tags: ['pop', 'alternative', 'live-music', 'ostpol'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-queer-monday',
    title: 'Queer Monday Open Stage',
    description:
      'A welcoming queer-friendly open-stage evening featuring music, poetry, comedy, drag performances, and spontaneous creativity. Whether you\'re here to perform or just cheer from the crowd, this Monday open stage is a genuine safe space where Dresden\'s queer community gathers to express, celebrate, and connect.',
    location: 'Königsbrücker Str. 47, 01099 Dresden',
    address: 'Königsbrücker Str. 47, 01099 Dresden',
    venueName: 'Ostpol',
    city: 'Dresden',
    category: 'social',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Ostpol',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '19:00',
    endTime: '22:30',
    coordinates: { lat: 51.0661, lng: 13.7382 },
    coverImageUrl: IMG('Cafe_night_diverse_people_talking_202605090203.jpeg'),
    coverPhoto: IMG('Cafe_night_diverse_people_talking_202605090203.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    musicGenres: ['Mixed'],
    hashtags: ['QueerMonday', 'OpenStage', 'Dresden', 'Community', 'SafeSpace'],
    tags: ['queer', 'open-stage', 'community', 'safe-space', 'drag'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-kickermontag',
    title: 'Kickermontag @ GrooveStation',
    description:
      'GrooveStation transforms into a social games arena every Monday with table football, billiards, ping pong, drinks, and student-friendly vibes. No entry fee, affordable drinks, and a crowd that\'s here to have genuine fun. A great way to shake off the Monday blues and actually enjoy the start of the week.',
    location: 'Katharinenstraße 11-13, 01099 Dresden',
    address: 'Katharinenstraße 11-13, 01099 Dresden',
    venueName: 'GrooveStation',
    city: 'Dresden',
    category: 'social',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'GrooveStation',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '19:00',
    endTime: '01:00',
    coordinates: { lat: 51.0649, lng: 13.7390 },
    coverImageUrl: IMG('International_student_social_party_202605090203.jpeg'),
    coverPhoto: IMG('International_student_social_party_202605090203.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    musicGenres: ['Social'],
    hashtags: ['GrooveStation', 'Kickermontag', 'StudentLife', 'Dresden'],
    tags: ['student', 'social', 'kicker', 'table-football', 'monday'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-sazon-montuno',
    title: 'Sazón Montuno – Live Latin Night',
    description:
      'Dance into the night with Sazón Montuno performing authentic salsa inspired by the legendary Fania era. Expect rhythmic percussion, brass sections, and warm Latin energy in the heart of Neustadt. The band navigates Afro-Cuban tradition with clave rhythms driving timbales, congas, piano, bass, brass and voices into a joyful, irresistible whole.',
    location: 'Alaunstraße 36-40, 01099 Dresden',
    address: 'Alaunstraße 36-40, 01099 Dresden',
    venueName: 'Scheune Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Scheune Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '19:30',
    endTime: '23:30',
    coordinates: { lat: 51.0669, lng: 13.7415 },
    coverImageUrl: IMG('Music_festival_sunset_diverse_crowd_202605090203_2.jpeg'),
    coverPhoto: IMG('Music_festival_sunset_diverse_crowd_202605090203_2.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Salsa', 'Latin Jazz'],
    hashtags: ['Salsa', 'LatinNight', 'Scheune', 'LiveMusic', 'Dresden'],
    tags: ['salsa', 'latin-jazz', 'live-music', 'dance', 'scheune'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-calmund',
    title: 'Reiner Calmund – Fußball & Freunde',
    description:
      'Legendary football personality Reiner Calmund hosts an entertaining evening full of football stories, humor, insider moments, and special guests at Alter Schlachthof. One of German football\'s most recognizable characters, Calmund delivers sharp anecdotes from the Bundesliga\'s golden years with his signature warmth and humor.',
    location: 'Gothaer Straße 11, 01097 Dresden',
    address: 'Gothaer Straße 11, 01097 Dresden',
    venueName: 'Alter Schlachthof',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Alter Schlachthof',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '20:00',
    endTime: '23:00',
    coordinates: { lat: 51.0556, lng: 13.7418 },
    coverImageUrl: IMG('Rooftop_party_dancing_with_cockt…_202605090203.jpeg'),
    coverPhoto: IMG('Rooftop_party_dancing_with_cockt…_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Entertainment'],
    hashtags: ['Football', 'Entertainment', 'AlterSchlachthof', 'Dresden'],
    tags: ['football', 'entertainment', 'talk-show', 'comedy'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-jazzfanatics',
    title: 'Jazzfanatics Live @ Zentralwerk',
    description:
      'Jazzfanatics deliver an energetic evening blending bebop, hard-bop, funk, and jazz fusion in the creative industrial atmosphere of Zentralwerk. This isn\'t background music — it\'s the kind of jazz that demands your attention and rewards it completely. Zentralwerk\'s raw brick walls and open space give the sound a warmth and presence that purpose-built jazz clubs rarely achieve.',
    location: 'Riesaer Straße 32, 01127 Dresden',
    address: 'Riesaer Straße 32, 01127 Dresden',
    venueName: 'Zentralwerk',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Zentralwerk',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '20:00',
    endTime: '23:30',
    coordinates: { lat: 51.0804, lng: 13.7263 },
    coverImageUrl: IMG('Techno_rave_in_warehouse_club_202605090203.jpeg'),
    coverPhoto: IMG('Techno_rave_in_warehouse_club_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Jazz', 'Funk', 'Fusion'],
    hashtags: ['Jazz', 'Fusion', 'LiveMusic', 'DresdenJazz', 'Zentralwerk'],
    tags: ['jazz', 'fusion', 'funk', 'bebop', 'live-music'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-dixieland-wohnzimmer',
    title: 'Wohnzimmerkonzert – Dixieland Festival',
    description:
      'An intimate jazz living-room concert as part of Dresden\'s legendary Dixieland Festival. Warm atmosphere, classic brass sounds, and vintage festival energy. Hoppe\'s Hoftheater provides the ideal setting — intimate without feeling cramped, historic without feeling stiff. Expect cornet, trombone, clarinet, tuba and drums filling the room with joy.',
    location: 'Hauptstraße 35, 01097 Dresden',
    address: 'Hauptstraße 35, 01097 Dresden',
    venueName: "Hoppe's Hoftheater",
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: "Hoppe's Hoftheater",
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '20:00',
    endTime: '22:30',
    coordinates: { lat: 51.0579, lng: 13.7392 },
    coverImageUrl: IMG('Candlelight_concert_in_hall_202605090203_3.jpeg'),
    coverPhoto: IMG('Candlelight_concert_in_hall_202605090203_3.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Dixieland Jazz'],
    hashtags: ['Dixieland', 'Jazz', 'Festival', 'Dresden', 'WohnzimmerKonzert'],
    tags: ['dixieland', 'jazz', 'festival', 'concert', 'intimate', 'brass'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-dixietram',
    title: 'Dixietram Jazz Rundfahrt',
    description:
      'A moving jazz experience through Dresden aboard a historic tram with live Dixieland performances and guided commentary. Part of the International Dixieland Festival, the Dixietram rolls through Dresden\'s most scenic streets while musicians fill the carriage with traditional New Orleans jazz. Departs from Postplatz — book tickets in advance.',
    location: 'Postplatz, 01067 Dresden',
    address: 'Postplatz, 01067 Dresden',
    venueName: 'Dresden City Tram (Postplatz)',
    city: 'Dresden',
    category: 'adventure',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Dixieland Festival Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '14:00',
    endTime: '17:00',
    coordinates: { lat: 51.0504, lng: 13.7355 },
    coverImageUrl: IMG('Party_boat_cruise_city_skyline_202605090203.jpeg'),
    coverPhoto: IMG('Party_boat_cruise_city_skyline_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Jazz', 'Dixieland'],
    hashtags: ['Dixieland', 'JazzTram', 'DresdenExperience', 'JazzFestival'],
    tags: ['dixieland', 'jazz-tram', 'experience', 'city-tour', 'festival'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-huettenkase',
    title: 'Hüttenkäse – Theater im Kulturpalast',
    description:
      'A clever and humorous theatre production about three stranded pilgrims navigating absurd conversations, philosophy, and modern life without internet access. Hüttenkäse strips its protagonists of connectivity and watches what happens when humans are forced to actually talk to each other — sharp, surprisingly philosophical, and very funny.',
    location: 'Schloßstraße 2, 01067 Dresden',
    address: 'Schloßstraße 2, 01067 Dresden',
    venueName: 'Kulturpalast Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Kulturpalast Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '19:30',
    endTime: '22:00',
    coordinates: { lat: 51.0506, lng: 13.7393 },
    coverImageUrl: IMG('Cafe_night_diverse_people_talking_202605090203_2.jpeg'),
    coverPhoto: IMG('Cafe_night_diverse_people_talking_202605090203_2.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Comedy'],
    hashtags: ['Comedy', 'Theatre', 'Kulturpalast', 'Dresden', 'Satire'],
    tags: ['comedy', 'theatre', 'kulturpalast', 'satire', 'philosophy'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-moving-shadows',
    title: 'Moving Shadows – On Fire',
    description:
      'Award-winning shadow artists create stunning visual illusions and emotional storytelling using light, silhouettes, movement, and live performance artistry. "On Fire" weaves stories of passion, loss, triumph, and human connection through shadow forms that feel startlingly alive. An unmissable evening for anyone who believes performance can genuinely move you.',
    location: 'Maternistraße 17, 01067 Dresden',
    address: 'Maternistraße 17, 01067 Dresden',
    venueName: 'Boulevardtheater Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Boulevardtheater Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '19:30',
    endTime: '21:30',
    coordinates: { lat: 51.0473, lng: 13.7289 },
    coverImageUrl: IMG('Festival_stage_with_pyrotechnics_202605090203.jpeg'),
    coverPhoto: IMG('Festival_stage_with_pyrotechnics_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Shadow Theatre'],
    hashtags: ['MovingShadows', 'Theatre', 'PerformanceArt', 'Dresden', 'ShadowArt'],
    tags: ['shadow-theatre', 'performance-art', 'visual-art', 'dance'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-traeume-europa',
    title: 'Träume in Europa',
    description:
      'A poetic and surreal theatre experience exploring dreams, fears, and hopes across Europe through interconnected narratives. The Staatsschauspiel\'s production follows characters from Dresden, Brussels, Kyiv, Lisbon, and Istanbul whose stories weave together in the space between sleep and waking — multi-lingual, visually inventive, and genuinely of this moment.',
    location: 'Theaterstraße 2, 01067 Dresden',
    address: 'Theaterstraße 2, 01067 Dresden',
    venueName: 'Staatsschauspiel Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Staatsschauspiel Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '19:30',
    endTime: '22:00',
    coordinates: { lat: 51.0524, lng: 13.7347 },
    coverImageUrl: IMG('Festival_stage_with_pyrotechnics_202605090203_2.jpeg'),
    coverPhoto: IMG('Festival_stage_with_pyrotechnics_202605090203_2.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Drama'],
    hashtags: ['Drama', 'Theatre', 'DresdenCulture', 'Staatsschauspiel', 'Europa'],
    tags: ['drama', 'theatre', 'surreal', 'poetic', 'multi-lingual'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-schone-lart',
    title: 'Gerhard Schöne & L\'Art de Passage',
    description:
      'Singer-songwriter Gerhard Schöne performs together with L\'Art de Passage in a heartfelt evening blending poetic lyrics, storytelling, and acoustic instrumentation. Schöne has been writing songs that matter for over forty years — songs rooted in humanity and curiosity. Together with L\'Art de Passage, his melodies gain new dimensions through strings and woodwinds.',
    location: 'Freiberger Straße 39, 01067 Dresden',
    address: 'Freiberger Straße 39, 01067 Dresden',
    venueName: 'Comödie Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Comödie Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '19:30',
    endTime: '22:00',
    coordinates: { lat: 51.0465, lng: 13.7248 },
    coverImageUrl: IMG('Candlelight_concert_in_hall_202605090203_4.jpeg'),
    coverPhoto: IMG('Candlelight_concert_in_hall_202605090203_4.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Chanson', 'Folk'],
    hashtags: ['GerhardSchöne', 'LiveMusic', 'Folk', 'Dresden', 'Chanson'],
    tags: ['chanson', 'folk', 'singer-songwriter', 'acoustic', 'concert'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-to-the-wire',
    title: 'To The Wire – Live Metal @ Café Pawlow',
    description:
      'Heavy riffs and raw underground energy take over Café Pawlow as To The Wire delivers an intense live metal performance. This is no arena show — it\'s five people with instruments in a room where you can feel the bass in your chest. To The Wire play with the conviction of a band who have nothing to prove and everything to give.',
    location: 'Görlitzer Straße 9, 01099 Dresden',
    address: 'Görlitzer Straße 9, 01099 Dresden',
    venueName: 'Café Pawlow',
    city: 'Dresden',
    category: 'nightlife',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Café Pawlow',
    startDate: '2026-05-11',
    endDate: '2026-05-11',
    startTime: '18:00',
    endTime: '21:00',
    coordinates: { lat: 51.0657, lng: 13.7452 },
    coverImageUrl: IMG('Rock_club_party_crowd_singing_202605090203.jpeg'),
    coverPhoto: IMG('Rock_club_party_crowd_singing_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Metal'],
    hashtags: ['Metal', 'LiveMusic', 'CafePawlow', 'Dresden', 'Underground'],
    tags: ['metal', 'live-music', 'underground', 'hard-rock', 'alternative'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  // ─── Ongoing Exhibitions & Markets ──────────────────────────────────────────
  {
    id: 'dresden-may11-fruehjahrsmarkt',
    title: 'Dresdner Frühjahrsmarkt',
    description:
      "Dresden's beloved spring market at the Altmarkt with dozens of vendors, seasonal foods, handcrafted goods, live entertainment, and a festive atmosphere. Browse stalls of local honey, artisan cheeses, handmade ceramics, fresh flowers, and regional spirits. Regional chefs prepare street food, and live music floats across the square throughout the day.",
    location: 'Altmarkt, 01067 Dresden',
    address: 'Altmarkt, 01067 Dresden',
    venueName: 'Altmarkt Dresden',
    city: 'Dresden',
    category: 'social',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Stadt Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-18',
    startTime: '10:00',
    endTime: '21:00',
    coordinates: { lat: 51.0503, lng: 13.7381 },
    coverImageUrl: IMG('Music_festival_sunset_diverse_crowd_202605090203.jpeg'),
    coverPhoto: IMG('Music_festival_sunset_diverse_crowd_202605090203.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    hashtags: ['Frühjahrsmarkt', 'SpringMarket', 'Dresden', 'Altmarkt', 'LocalFood'],
    tags: ['market', 'spring', 'food', 'handmade', 'altmarkt', 'community'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-illusionswelt',
    title: 'Illusionswelt – Die Ausstellung',
    description:
      'An immersive exhibition where perception becomes the subject — optical illusions, trick rooms, infinity mirrors, and mind-bending interactive installations challenge everything you think you know about reality. Illusionswelt has attracted over half a million visitors across its European tour. Perfect for all ages — children love the wonder, adults find themselves equally baffled.',
    location: 'Messering 6, 01067 Dresden',
    address: 'Messering 6, 01067 Dresden',
    venueName: 'Messe Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Messe Dresden',
    startDate: '2026-05-11',
    endDate: '2026-06-01',
    startTime: '10:00',
    endTime: '19:00',
    coordinates: { lat: 51.0325, lng: 13.7276 },
    coverImageUrl: IMG('Disco_dance_floor_with_mirror_202605090203.jpeg'),
    coverPhoto: IMG('Disco_dance_floor_with_mirror_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    hashtags: ['Illusionswelt', 'Exhibition', 'OpticalIllusion', 'Dresden', 'Family'],
    tags: ['exhibition', 'illusions', 'interactive', 'optical-art', 'family'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-bluetenwunder',
    title: 'Blütenwunder 2026 – Schlosspark Pillnitz',
    description:
      "Pillnitz Castle's legendary gardens reach peak bloom in May, celebrating the season with guided tours, botanical talks, and the spectacle of the world's oldest potted camellia in full spring glory. The park holds over 800 species of trees and shrubs, many centuries old. Rhododendrons, magnolias, and flowering cherry trees create a layered tapestry of colour against baroque facades.",
    location: 'August-Böckstiegel-Straße 2, 01326 Dresden',
    address: 'August-Böckstiegel-Straße 2, 01326 Dresden',
    venueName: 'Schloss & Park Pillnitz',
    city: 'Dresden',
    category: 'adventure',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Schloss Pillnitz',
    startDate: '2026-05-11',
    endDate: '2026-05-25',
    startTime: '09:00',
    endTime: '18:00',
    coordinates: { lat: 51.0197, lng: 13.8715 },
    coverImageUrl: IMG('Music_festival_sunset_diverse_crowd_202605090203_3.jpeg'),
    coverPhoto: IMG('Music_festival_sunset_diverse_crowd_202605090203_3.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    hashtags: ['Blütenwunder', 'Pillnitz', 'Spring', 'Garden', 'Dresden', 'Botanical'],
    tags: ['garden', 'park', 'pillnitz', 'spring', 'botanical', 'outdoor', 'family'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-galerie-kuehl',
    title: 'Kunstausstellung Kühl – Frühlingsschau 2026',
    description:
      "Galerie Kühl's Frühlingsschau brings together a curated selection of contemporary paintings, sculptures, and works on paper by established and emerging artists working in and around Dresden. The gallery, one of Saxony's most respected private exhibition spaces, has assembled a show that challenges easy categorization — figurative work that speaks abstractly, abstract work with deeply personal roots.",
    location: 'Rähnitzgasse 8, 01097 Dresden',
    address: 'Rähnitzgasse 8, 01097 Dresden',
    venueName: 'Galerie Kühl',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Galerie Kühl',
    startDate: '2026-05-11',
    endDate: '2026-05-31',
    startTime: '11:00',
    endTime: '18:00',
    coordinates: { lat: 51.0587, lng: 13.7397 },
    coverImageUrl: IMG('Wine_tasting_evening_vineyard_lo…_202605090203.jpeg'),
    coverPhoto: IMG('Wine_tasting_evening_vineyard_lo…_202605090203.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    hashtags: ['KunstausstellungKühl', 'Gallery', 'Art', 'Dresden', 'Contemporary'],
    tags: ['art', 'gallery', 'exhibition', 'painting', 'sculpture', 'contemporary'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-kotzsch-fotografie',
    title: 'August Kotzsch – Dresdner Fotografien',
    description:
      'A retrospective of August Kotzsch (1836–1910), whose photographs documented Dresden and the surrounding Elbe valley with extraordinary sensitivity at a time when photography was still redefining what images could be. This Stadtmuseum retrospective draws on archives across Saxony to assemble the most comprehensive survey of his work in decades.',
    location: 'Wilsdruffer Str. 2, 01067 Dresden',
    address: 'Wilsdruffer Str. 2, 01067 Dresden',
    venueName: 'Stadtmuseum Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Stadtmuseum Dresden',
    startDate: '2026-05-11',
    endDate: '2026-07-12',
    startTime: '10:00',
    endTime: '18:00',
    coordinates: { lat: 51.0500, lng: 13.7373 },
    coverImageUrl: IMG('Cafe_night_diverse_people_talking_202605090203_3.jpeg'),
    coverPhoto: IMG('Cafe_night_diverse_people_talking_202605090203_3.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    hashtags: ['Kotzsch', 'Photography', 'History', 'Dresden', 'Stadtmuseum'],
    tags: ['photography', 'exhibition', 'historical', 'kotzsch', 'stadtmuseum'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-uhlmann-schach',
    title: 'Wolfgang Uhlmann – Leben im Schach',
    description:
      "A tribute exhibition to Wolfgang Uhlmann (1935–2020), Dresden's greatest chess grandmaster. Through photographs, archival documents, game records, and memorabilia, the exhibition traces a life lived in the world of chess — from GDR tournaments to Cold War matches against Fischer and Karpov. Chess sets available to replay his most celebrated games.",
    location: 'Schloßstraße 2, 01067 Dresden',
    address: 'Schloßstraße 2, 01067 Dresden',
    venueName: 'Kulturpalast Dresden (Foyer)',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Kulturpalast Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-31',
    startTime: '10:00',
    endTime: '18:00',
    coordinates: { lat: 51.0506, lng: 13.7393 },
    coverImageUrl: IMG('International_student_social_party_202605090203_2.jpeg'),
    coverPhoto: IMG('International_student_social_party_202605090203_2.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    hashtags: ['Schach', 'Uhlmann', 'Chess', 'Dresden', 'Exhibition', 'History'],
    tags: ['chess', 'exhibition', 'grandmaster', 'history', 'kulturpalast'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-heliografien',
    title: 'Heliografien – Thomas Bachler',
    description:
      "Thomas Bachler's Heliografien series uses the world's oldest photographic technique — heliography, invented by Niépce in 1826 — to create images that sit somewhere between photography and painting. Each piece requires hours of direct sunlight, made literally by light itself. The tonal quality is unlike anything digital: soft, luminous, possessing a depth that rewards sustained looking.",
    location: 'Junghansstraße 1-3, 01277 Dresden',
    address: 'Junghansstraße 1-3, 01277 Dresden',
    venueName: 'Technische Sammlungen Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Technische Sammlungen Dresden',
    startDate: '2026-05-11',
    endDate: '2026-06-28',
    startTime: '09:00',
    endTime: '17:00',
    coordinates: { lat: 51.0481, lng: 13.7777 },
    coverImageUrl: IMG('Disco_dance_floor_with_mirror_202605090203_2.jpeg'),
    coverPhoto: IMG('Disco_dance_floor_with_mirror_202605090203_2.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    hashtags: ['Heliografien', 'Photography', 'ArtExhibition', 'Dresden', 'TechnischeSammlungen'],
    tags: ['photography', 'heliography', 'art', 'exhibition', 'bachler'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: 'dresden-may11-licht-schatten',
    title: 'Licht, Schatten, Bewegung – Ausstellung',
    description:
      "An interdisciplinary exhibition exploring the relationship between light, shadow, and movement in visual art, dance, and installation. Five artists from Dresden, Leipzig, and Berlin have created site-specific works in response to the Societaetstheater's unusual spaces. Some works are static, some kinetic, some responsive to the viewer's presence — all reward slow, attentive visiting.",
    location: 'An der Dreikönigskirche 1a, 01097 Dresden',
    address: 'An der Dreikönigskirche 1a, 01097 Dresden',
    venueName: 'Societaetstheater Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Societaetstheater Dresden',
    startDate: '2026-05-11',
    endDate: '2026-05-25',
    startTime: '11:00',
    endTime: '19:00',
    coordinates: { lat: 51.0568, lng: 13.7393 },
    coverImageUrl: IMG('Festival_stage_with_pyrotechnics_202605090203_3.jpeg'),
    coverPhoto: IMG('Festival_stage_with_pyrotechnics_202605090203_3.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    hashtags: ['LichtSchattenBewegung', 'Art', 'Installation', 'Dresden', 'Exhibition'],
    tags: ['art', 'installation', 'light', 'shadow', 'movement', 'exhibition'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
];
